export default [
  {
    path: '/college-regist/welcome',
    name: 'college_regist_welcome',
    component: () => import('../../views/college-regist/Welcome.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '学生登记进班',
      keepAlive: true,
    },
  },
  {
    path: '/college-regist/phone',
    name: 'college_regist_phone',
    component: () => import('../../views/college-regist/Phone.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '账号验证',
    },
  },
  {
    path: '/college-regist/form',
    name: 'college_regist_form',
    component: () => import('../../views/college-regist/Form.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '完善信息',
    },
    children: [
      {
        path: 'improve-info',
        name: 'college_regist_improve_info',
        component: () => import('../../views/college-regist/ImproveInfo.vue'),
        props: (route: any) => ({ ...route.query, ...route.params }),
        meta: {
          title: '完善信息',
        },
      },
      {
        path: 'subject',
        name: 'college_regist_subject',
        component: () => import('../../views/college-regist/SelectSubject.vue'),
        props: (route: any) => ({ ...route.query, ...route.params }),
        meta: {
          title: '选择专业班',
        },
      },
      {
        path: 'teacher',
        name: 'college_regist_teacher',
        component: () => import('../../views/college-regist/SelectTeacher.vue'),
        props: (route: any) => ({ ...route.query, ...route.params }),
        meta: {
          title: '选择老师',
        },
      },
      {
        path: 'create-clazz',
        name: 'college_regist_create_clazz',
        component: () => import('../../views/college-regist/CreateClazz.vue'),
        props: (route: any) => ({ ...route.query, ...route.params }),
        meta: {
          title: '创建班级',
        },
      },
    ],
  },
  {
    path: '/college-regist/success',
    name: 'college_regist_success',
    component: () => import('../../views/college-regist/Success.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '',
    },
  },
]
